import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, Typography, Button, Box, Grid, Accordion, AccordionSummary, AccordionDetails , Container } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import VideoSection from './VideoSection';
import FeaturesSection from './FeaturesSection';
import './home.css';
import ImageCarousel from "./ImageCarousel";
import HeadlineSection from "./headlineSection";
import Header from "./Header";
import LoginPopup from "../../components/Login/LoginPopup";
import { CIRCUIT_IMAGES } from "../../constants/Constants";
import Auth from "../Auth/Auth";
import { useLocation } from "react-router-dom";

const HomePage = () => {
    useLocation();      //To handle logout and show the buttons
    const [openLogin, setOpenLogin] = useState(false);
    const { isLoggedIn } = Auth();

    const faqs = [
        { q: "What is this platform?", a: `A web-based tool that helps VLSI enthusiasts build familiarity and competency in schematics and stick diagrams—foundational skills for kick-starting a career in the semiconductor industry (for roles such as Layout Engineer, Design Engineer, and Physical Design Engineer).\n\r` },
        { q: "How do I sign up?", a: "Click the signup button on the top-right corner and follow the steps." },
        { q: "Is there a free trial?", a: "Yes! You can try our platform for free. The free trial lasts for a limited period and includes access to selected features." },
    ];

    return (
        <Container >
            {/* <Header /> */}
            <Box>
                <Grid container spacing={1} justifyContent="center">
                    <Grid size={{ xs: 12, sm: 6 }} sx={{display: "flex", alignItems: "center"}} p={0} m={0}>
                        <HeadlineSection/>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <ImageCarousel items={CIRCUIT_IMAGES} />
                    </Grid>
                    {/* <Grid size={{ xs: 12, sm: 6 }}>
                        <VideoSection />
                    </Grid> */}
                    {/* <Grid size={{ xs: 12 }}>
                        <FeaturesSection />
                    </Grid> */}
                </Grid>

                <Box sx={{ mt: 2}}>
                    <Typography variant="h1" gutterBottom fontWeight="bold">FAQ</Typography>
                    {faqs.map((faq, i) => (
                        <Accordion key={i} sx={{mb:1}}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography variant="h6" fontWeight="bold" >{faq.q}</Typography></AccordionSummary>
                            <AccordionDetails><Typography variant="body1" sx={{whiteSpace: "pre-line"}}>{faq.a}</Typography></AccordionDetails>
                        </Accordion>
                    ))}
                </Box>
                
                <Box sx={{ py: 3, textAlign: "left" , display:"flex" , flexDirection:{xs:"column", sm:"row"}, justifyContent:"space-between", alignItems:"center",  gap: 2, mb:5}}>
                    {!isLoggedIn && (
                    <>
                    <Typography sx={{ fontWeight:"bold",fontSize: { xs: "1.1rem", sm: "2rem", md: "2.5rem" } }}>
                        Ready to build your first diagram?
                    </Typography>
                    <Button variant="contained" size="large" sx={{ borderRadius: 2 }} onClick={()=>{setOpenLogin(true)}}>
                        Sign up
                    </Button>
                    </>
                    )}
                </Box>
            </Box>
            {openLogin && <LoginPopup open={openLogin} onClose={()=>{setOpenLogin(false)}} />}
        </Container>
    );
};

export default HomePage;
